import service from './product.service'
import template from './product.html'
import controller from './product.controller'
import './product.scss'

let module = angular.module('product', [
	'ionic',
	'app.config'
])
.service('Product', service)
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.product', {
			url: '/product/:uid?:query&:ref',
			views: {
				'tab-search': {
					template: template,
					controller: controller,
					controllerAs: '$ctrl'
				}
			},

		})
})
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/product/product.js